import { useEffect, useRef, useState } from 'react';
import { obtenerCliente, obtenerProyectosXCliente, obtieneDatosDinaXPuesto, registraCliente, registraProyecto, registraPuesto, registrarHoraDinamica } from '../../services/Monitor/ComunicacionService';
import { getPuestosDinamicos, obtieneTodosEmpleados } from '../../services/Monitor/MonitorService';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { convertFechaString, convertHoraString } from './util';

export const usePuestoTemp = () => {
    const [cliente, setCliente] = useState();
    const [lstCliente, setLstCliente] = useState([]);
    const [cargaCliente, setCargaCliente] = useState(false);
    const [refresca, setRefresca] = useState(false);

    const [proyecto, setProyecto] = useState();
    const [lstProyecto, setLstProyecto] = useState([]);
    const [cargaProyecto, setCargaProyecto] = useState(false);
    const [refreProy, setRefreProy] = useState(false);

    const [puesto, setPuesto] = useState();
    const [lstPuesto, setLstPuesto] = useState([]);
    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [refrePues, setRefrePues] = useState(false);

    const [lstEmpleados, setLstEmpleados] = useState([]);
    const [cargaEmpleado, setCargaEmpleado] = useState(false);

    const [empleadoSelect, setEmpleadoSelect] = useState([]);

    const [visibleCreaCli, setVisibleCreaCli] = useState(false);
    const [visibleCreaProy, setVisibleCreaProy] = useState(false);
    const [visibleCreaPues, setVisibleCreaPues] = useState(false);
    const [enproceso, setEnproceso] = useState(false);

    function createInitialDate() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }

    const [fechaIni, setFechaIni] = useState(createInitialDate);
    const [fechaFin, setFechaFin] = useState(createInitialDate);

    const [filasFecha, setFilasFecha] = useState([]);
    const [horaIniGen, setHoraIniGen] = useState(new Date());
    const [horaFinGen, setHoraFinGen] = useState(new Date());

    const [disaButCopiar, setDisaButCopiar] = useState(true);
    const [disaButGuardar, setDisaButGuardar] = useState(true);
    const [disaButConsultar, setDisaButConsultar] = useState(true);
    const [loadConsultar, setLoadConsultar] = useState(false);
    const [loadGuardar, setLoadGuardar] = useState(false);

    const toast = useRef();

    useEffect(() => {
        const getClientes = async () => {
            try {
                setCargaCliente(true);
                const miData = await obtenerCliente();
                setLstCliente(miData);
            } catch (error) {
                console.error('Error al obtener Clientes');
            } finally {
                setCargaCliente(false);
            }
        };
        getClientes();
    }, [refresca]);

    useEffect(() => {
        const getEmpleados = async () => {
            try {
                setCargaEmpleado(true);
                const miResponse = await obtieneTodosEmpleados();
                //console.log('00JJ:', miResponse)
                setLstEmpleados(miResponse);
            } catch (error) {
                console.error('Error al conseguir Empleados');
            } finally {
                setCargaEmpleado(false);
            }
        };
        getEmpleados();
    }, []);

    useEffect(() => {
        const getProyecto = async () => {
            if (cliente) {
                try {
                    setCargaProyecto(true);
                    const miData = await obtenerProyectosXCliente(cliente.clienteId);
                    setLstProyecto(miData);
                } catch (error) {
                    console.error('Error al obtener Proyecto');
                } finally {
                    setCargaProyecto(false);
                }
            }
        };
        getProyecto();
    }, [cliente, refreProy]);

    useEffect(() => {
        const getPuesto = async () => {
            if (proyecto) {
                setCargaPuesto(true);
                try {
                    //const miData = await obtenerPuestoAdm(proyecto.proyectoId);
                    const miData = await getPuestosDinamicos(proyecto.proyectoId);
                    setLstPuesto(miData);
                    setDisaButConsultar(false);
                } catch (error) {
                    console.error('Error al obtener Puestos');
                } finally {
                    setCargaPuesto(false);
                }
            }
        };
        getPuesto();
    }, [proyecto, refrePues]);

    const guardarCliente = async (formData) => {
        try {
            const objPost = {
                nombre: formData.nombre,
                tipoId: 39,
                nroIdentificador: formData.identificador
            };
            const response = await registraCliente(objPost);
            if (response) {
                setRefresca((prev) => !prev);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se ha Guardado el Dato' });
            console.error('Error al guardar Cliente');
        } finally {
            setVisibleCreaCli(false);
        }
    };

    const guardarProyecto = async (formData) => {
        try {
            const objPost = {
                nombre: formData.nombre,
                clienteId: formData.cliente,
                sigla: formData.sigla
            };
            const miResponse = await registraProyecto(objPost);
            if (miResponse) {
                setRefreProy((prev) => !prev);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al registrar Proyecto' });
            console.error('Error al guardar Proyecto');
        } finally {
            setVisibleCreaProy(false);
        }
    };

    const guardarPuesto = async (formData) => {
        try {
            const objPost = {
                nombre: formData.nombre,
                proyectoId: formData.proyecto,
                sigla: formData.sigla,
                tipoPuesto: 'DINAMICO',
                puestoPadre: 0,
                telefonos: formData.telefono,
                codigo: '',
                ubicacion: '',
                codMarcaRapida: formData.codRapido
            };
            const miResponse = await registraPuesto(objPost);
            //console.log ('WWJJ0:', miResponse)
            if (miResponse) {
                setRefrePues((prev) => !prev);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al registrar Puesto' });
            console.error('Error al guardar Puesto');
        } finally {
            setVisibleCreaPues(false);
        }
    };

    const handleNuevoCli = () => {
        setVisibleCreaCli(true);
    };

    const handleNuevoProy = () => {
        if (cliente) {
            setVisibleCreaProy(true);
        } else {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Cliente' });
        }
    };

    const optionProyectoTemplate = (option) => {
        if (option) {
            return `${option.sigla} - ${option.nombre}`;
        }
        return 'Selecciona un Proyecto';
    };

    const handleChangePuesto = (evt) => {
        //
        setPuesto(evt.value);
    };

    const handleNuevoPuesto = () => {
        if (proyecto) {
            setVisibleCreaPues(true);
        } else {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Proyecto' });
        }
    };

    const generaFechas02 = (ini, fin, lstDatos) => {
        // construye el mapa
        const datosPorFecha = lstDatos.reduce((acc, current) => {
            const nuevoReg = {
                id: new Date().getTime() + Math.random(),
                fecha: current.fechaDat,
                horaIni: current.horaIniData,
                horaFin: current.horaFinData,
                descripcion: 'fecha',
                listaEmpleados: current.listaEmp
            };
            if (!acc[current.fechaDat]) {
                acc[current.fechaDat] = [];
            }
            acc[current.fechaDat].push(nuevoReg);
            return acc;
        }, {});
        const listaCompleta = [];
        let currentDate = new Date(ini);
        currentDate.setHours(0, 0, 0, 0);
        while (currentDate <= fin) {
            const registrosExistentes = datosPorFecha[currentDate];
            if (registrosExistentes) {
                listaCompleta.push(...registrosExistentes);
            } else {
                listaCompleta.push({
                    id: new Date().getTime() + Math.random(),
                    fecha: new Date(currentDate),
                    horaIni: null,
                    horaFin: null,
                    descripcion: 'fecha:',
                    listaEmpleados: []
                });
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return listaCompleta;
    };

    const fechasFromResponse = (lstDatos) => {
        return lstDatos.map((item) => {
            const fecha = new Date(item.fecha.year, item.fecha.monthValue - 1, item.fecha.dayOfMonth);
            const hoy1 = new Date();
            hoy1.setHours(item.horaInicio.hour, item.horaInicio.minute, item.horaInicio.second);
            const hoy2 = new Date();
            hoy2.setHours(item.horaFin.hour, item.horaFin.minute, item.horaFin.second);
            return {
                fechaDat: fecha,
                horaIniData: hoy1,
                horaFinData: hoy2,
                listaEmp: item.empleadosId
            };
        });
    };

    const handleConsultar = async () => {
        if (!(puesto && fechaIni && fechaFin)) {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar los campos Fecha Desde, Fecha Hasta y puesto.' });
            return;
        }
        try {
            setFilasFecha([]);
            setDisaButCopiar(true);
            setDisaButGuardar(true);
            setLoadConsultar(true);
            fechaIni.setHours(0, 0, 0, 0);
            fechaFin.setHours(0, 0, 0, 0);
            const objPost = {
                puestoId: puesto.id,
                fechaDesde: convertFechaString(fechaIni),
                fechaHasta: convertFechaString(fechaFin)
            };
            const miResponse = await obtieneDatosDinaXPuesto(objPost);
            //obtener la version de fechas de la respuesta
            const lstFechasBD = fechasFromResponse(miResponse);
            // llenar el dataTable
            //const nuevasFilas = generaFechas(fechaIni, fechaFin, lstFechasBD);

            const nuevasFilas = generaFechas02(fechaIni, fechaFin, lstFechasBD);
            setFilasFecha(nuevasFilas);
            setDisaButCopiar(false);
            setDisaButGuardar(false);
            // validar los datos
        } catch (error) {
            console.error('Error al consultar datos.', error.message);
        } finally {
            setLoadConsultar(false);
        }
    };

    const dateBodyTemplate = (fila) => {
        return fila.fecha.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        });
    };

    const calendarIniBodyTemplate = (fila) => {
        return <Calendar value={fila.horaIni} onChange={(e) => actualizaHora(fila, 'horaIni', e.value)} timeOnly />;
    };
    const calendarFinBodyTemplate = (fila) => {
        return <Calendar value={fila.horaFin} onChange={(e) => actualizaHora(fila, 'horaFin', e.value)} timeOnly />;
    };

    const actualizaHora = (fila, campo, nuevoValor) => {
        const filasActualizadas = filasFecha.map((item) => (item.id === fila.id ? { ...item, [campo]: nuevoValor } : item));
        setFilasFecha(filasActualizadas);
    };

    const llenarHoras = () => {
        const nuevaFila = filasFecha.map((item) => {
            const horaTIni = item.horaIni === null ? horaIniGen : item.horaIni;
            const horaTFin = item.horaFin === null ? horaFinGen : item.horaFin;
            const listaTFin = item.listaEmpleados.length === 0 ? empleadoSelect : item.listaEmpleados;
            return {
                ...item,
                horaIni: horaTIni,
                horaFin: horaTFin,
                listaEmpleados: listaTFin
            };
        });
        setFilasFecha(nuevaFila);
    };

    const validarHorasCompletas = () => {
        //console.log(filasFecha);
        const filasIncompletas = filasFecha.filter((fila) => fila.horaInicio === null || fila.horaFin === null || fila.listaEmpleados.length === 0);

        const filasCompletas = filasFecha.filter((fila) => fila.horaInicio !== null && fila.horaFin !== null && fila.listaEmpleados.length !== 0);

        return {
            esValido: filasIncompletas.length === 0,
            filasIncompletas: filasIncompletas,
            filasCompletas: filasCompletas,
            total: filasFecha.length,
            completadas: filasCompletas.length
        };
    };

    const handleGuardar = async () => {
        //}
        if (!puesto) {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Puesto' });
            return;
        }
        const infoVal = validarHorasCompletas();
        if (!infoVal.esValido) {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Todas las filas deben tener Horas inicio, Hora final y Empleados Asignados' });
            return;
        }
        if (filasFecha) {
            if (filasFecha.length === 0) {
                toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'No se ha detectado la definición de Horarios.' });
                return;
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'No se ha detectado la definición de Horarios.' });
            return;
        }
        const listaHorarios = filasFecha.map((item) => ({
            puestoId: puesto.id,
            fecha: item.fecha.toISOString().split('T')[0],
            horaInicio: convertHoraString(item.horaIni),
            horaFin: convertHoraString(item.horaFin),
            listEmpleadosId: item.listaEmpleados
        }));
        const objPost = {
            puestoId: puesto.id,
            fechaInicio: convertFechaString(fechaIni),
            fechaFin: convertFechaString(fechaFin),
            listHorarios: listaHorarios
        };
        try {
            setLoadGuardar(true);
            setDisaButCopiar(true);
            setDisaButGuardar(true);
            setDisaButConsultar(true);
            //console.log('JJ0:', objPost);
            const miResponse = await registrarHoraDinamica(objPost);
            //const miResponse = 'hola';
            //console.log('ww00:', miResponse);
            const prefijo = 'ERROR:';
            if (miResponse.startsWith(prefijo)) {
                const mensaje = miResponse.substring(prefijo.length);
                toast.current.show({ severity: 'error', summary: 'Error', detail: mensaje });
            } else {
                toast.current.show({ severity: 'success', summary: 'Exito', detail: miResponse });
                setFilasFecha([]);
                setDisaButCopiar(true);
                setDisaButGuardar(true);
            }
        } catch (error) {
            console.error('Error: ', error.message);
        } finally {
            setLoadGuardar(false);
            setDisaButCopiar(false);
            setDisaButGuardar(false);
            setDisaButConsultar(false);
        }
    };

    const actionBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button icon="pi pi-plus" className="p-button-rounded p-button-info" tooltip="Adicionar Horario" onClick={() => addRow(rowIndex)} />
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger" tooltip="Eliminar Horario" onClick={() => deleteRow(rowIndex)} />
            </div>
        );
    };

    const addRow = (index) => {
        const newFilasFecha = [...filasFecha];
        const originalRow = newFilasFecha[index];
        //
        const newRow = {
            ...originalRow,
            // generar un Id unico
            id: new Date().getTime() + Math.random(),
            // Hora ini y hora fin inician en vacio
            horaIni: null,
            horaFin: null,
            listaEmpleados: []
        };
        newFilasFecha.splice(index + 1, 0, newRow);
        setFilasFecha(newFilasFecha);
    };

    const deleteRow = (index) => {
        if (filasFecha.length === 1) {
            //console.log('No se puede eliminar la última fila.');
            return;
        }
        const newFilasFecha = [...filasFecha];
        newFilasFecha.splice(index, 1);
        setFilasFecha(newFilasFecha);
    };

    const onMultiSelectChange = (e, rowData, rowIndex) => {
        const newFilasFecha = [...filasFecha];
        // Clonar el objeto de la fila para mantener la inmutabilidad
        const updatedRow = { ...rowData, listaEmpleados: e.value };
        // Reemplazar la fila antigua con la actualizada
        newFilasFecha[rowIndex] = updatedRow;
        // Actualizar el estado
        setFilasFecha(newFilasFecha);
    };

    const empleadoBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <MultiSelect
                value={rowData.listaEmpleados}
                options={lstEmpleados} // Opciones cargadas una vez
                onChange={(e) => onMultiSelectChange(e, rowData, rowIndex)}
                placeholder="Seleccionar Empleados"
                className="w-full"
                optionLabel="nombre"
                optionValue="personaId"
                maxSelectedLabels={1}
                filter
            />
        );
    };
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    return {
        toast,
        visibleCreaCli,
        setVisibleCreaCli,
        guardarCliente,
        visibleCreaProy,
        setVisibleCreaProy,
        guardarProyecto,
        visibleCreaPues,
        proyecto,
        guardarPuesto,
        cargaCliente,
        cliente,
        setCliente,
        lstCliente,
        handleNuevoCli,
        enproceso,
        cargaProyecto,
        setProyecto,
        lstProyecto,
        optionProyectoTemplate,
        handleNuevoProy,
        cargaPuesto,
        puesto,
        handleChangePuesto,
        lstPuesto,
        handleNuevoPuesto,
        fechaIni,
        setFechaIni,
        hoy,
        fechaFin,
        setFechaFin,
        handleConsultar,
        loadConsultar,
        disaButConsultar,
        cargaEmpleado,
        empleadoSelect,
        setEmpleadoSelect,
        lstEmpleados,
        horaIniGen,
        setHoraIniGen,
        horaFinGen,
        setHoraFinGen,
        llenarHoras,
        disaButCopiar,
        filasFecha,
        dateBodyTemplate,
        calendarIniBodyTemplate,
        calendarFinBodyTemplate,
        actionBodyTemplate,
        empleadoBodyTemplate,
        handleGuardar,
        disaButGuardar,
        loadGuardar,
        setVisibleCreaPues
    };
};
